import { EVENT_KEY_ESCAPE } from '../../../../constants/event'
import { useKeyboardListener } from '../../../../hooks'
import Modal, { Box } from '../../../Modal'
import { RentalPortalIntegrationsPanel } from '../RentalPortalIntegrationsPanel'

import { QA_NAME_INTEGRATIONS_PREVIEW_MODAL } from './IntegrationsPreviewModal.constants'

import * as styles from './IntegrationsPreviewModal.module.css'

function IntegrationsPreviewModal({
  canConfigure,
  connection,
  onChanged,
  onClose,
}) {
  useKeyboardListener({
    callback: onClose,
    dependencies: [onClose],
    eventKey: EVENT_KEY_ESCAPE,
  })

  return (
    <Modal qaName={QA_NAME_INTEGRATIONS_PREVIEW_MODAL} onClose={onClose}>
      <Box className={styles.box}>
        <RentalPortalIntegrationsPanel
          canConfigure={canConfigure}
          connection={connection}
          onChanged={onChanged}
          onClose={onClose}
        />
      </Box>
    </Modal>
  )
}

export default IntegrationsPreviewModal
